module.exports = __webpack_public_path__ + "WealthCare Saver HSA Transfer Due to Divorce Form.pdf";